import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Pegawai',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pegawai',
        href: '/adm/pegawai',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_employee',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'em_code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'em_name',
        label: 'Nama',
        sortable: true,
      },
      {
        key: 'em_phone',
        label: 'Phone',
        sortable: true,
      },
      {
        key: 'em_email',
        label: 'Email',
        sortable: true,
      },
      {
        key: 'em_user_name',
        label: 'User Name',
        sortable: true,
      },
      {
        key: 'em_status',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {},
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeEmployee(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchEmployee(context, params = null) {
    let result = await ApiGetRequest(`employee`, params);
    return !result.error ? result.data.object : [];
  },

  async getListEmployee({ commit, state }, payload = {}) {
    commit('changeEmployee', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`employee`, params);
      commit('changeEmployee', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_employee.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`employee`, params);
      commit('changeEmployee', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailEmployee({ commit, state }, payload = null) {
    commit('changeEmployee', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`employee/${payload.id}`);
    commit('changeEmployee', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
        password: '',
      },
    });

    return result.error ? false : true;
  },

  async uploadImageEmployee({ commit, state }, payload) {
    commit('changeEmployee', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeEmployee', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEmployee', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeEmployee', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`employee/import`, {
      items: data.import_form || [],
    });

    commit('changeEmployee', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createEmployee({ commit, state, dispatch }) {
    commit('changeEmployee', {
      loading: true,
    });

    let result = await ApiPostRequest(`employee`, state.data.form);
    commit('changeEmployee', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateEmployee({ commit, state, dispatch }, payload = null) {
    commit('changeEmployee', {
      loading: true,
    });

    let result = await ApiPutRequest(`employee/${payload.id}`, state.data.form);

    commit('changeEmployee', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteEmployee({ commit, dispatch }, payload = null) {
    commit('changeEmployee', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`employee/${payload.id}`);
    commit('changeEmployee', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
